import * as React from "react";

import { useTheme } from "@mui/material";

import { useTranslate } from "../../hooks/useTranslate";
import { FormTypography, FormTypographyProps } from "../forms-design-system/FormTypography";
import { NewTabLink } from "../Link/NewTabLink";

import { useDynamicThemeAwareVariables } from "@/features/FormV2/hooks/useDynamicThemeAwareVariables";

export const FormUserAgreement: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslate();
  const theme = useTheme();

  const { vibe } = useDynamicThemeAwareVariables(({ mode }) => ({
    vibe: (mode === "light" ? "moderate" : "supershy") as FormTypographyProps["vibe"],
  }));

  return (
    <FormTypography variant="caption" vibe={vibe}>
      {t("donationForm", "userAgreement.thisSite")}
      <NewTabLink
        href="https://policies.google.com/privacy"
        display="inline"
        sx={{ color: `${theme.palette.forms.text.brand} !important` }}
      >
        {t("donationForm", "userAgreement.privacyPolicy")}
      </NewTabLink>
      {t("donationForm", "userAgreement.and")}
      <NewTabLink
        href="https://policies.google.com/terms"
        display="inline"
        sx={{ color: `${theme.palette.forms.text.brand} !important` }}
      >
        {t("donationForm", "userAgreement.termOfService")}
      </NewTabLink>
      {t("donationForm", "userAgreement.apply")}
      <NewTabLink
        href="https://support.zeffy.com/data-privacy-policy"
        display="inline"
        sx={{ color: `${theme.palette.forms.text.brand} !important` }}
      >
        {t("donationForm", "userAgreement.privacyPolicy")}
      </NewTabLink>
      {t("donationForm", "userAgreement.end")}
    </FormTypography>
  );
};
